import {
  axiosAPI,
  axiosImageAPI,
} from '@/axios';
import axiosCancel from 'axios-cancel';
import store from '@/store';

const baseURL = process.env.VUE_APP_ORIGIN || window.location.origin;

const configAxios = () => {
  // Setup axios for app api.
  axiosAPI.defaults.withCredentials = true;
  axiosAPI.interceptors.response.use((response) => response, async (error) => {
    if (error.response && error.response.status === 401) {
      await store.dispatch('destoryCurrentUser');
      window.location.href = `${baseURL}/auth/login`;
    }
    return Promise.reject(error);
  });

  axiosImageAPI.defaults.withCredentials = true;
  axiosCancel(axiosImageAPI);
};

export {
  configAxios,
};
